import React, { Fragment } from 'react';

import Botones from '../../../components/UI/botonera/headerBotones.js';
import Division from '../../../components/UI/division/division.jsx';
import TablaFiltro from '../../../components/UI/tablaFiltro/tablaFiltroSort.jsx';

function ListaPlantillasInt(props) {

    return (
        <Fragment>
            <div className="col-md-12">
                <div className='row'>
                    <div className="col-md-6">
                        <h1>{props.titulo}</h1>
                    </div>
                    <div className="col-md-6 text-right">
                        <div className="acciones">
                            <Botones
                                botones={props.botones}
                            />
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="content-box box-primary">
                        <TablaFiltro
                            keyField={"ID"}
                            datos={props.listaDatos}
                            columnas={props.columnas}
                            condensed={false}
                            selectRow={props.selectRow}
                            modo={props.cellEdit}
                            borrar={false}
                            busqueda={true}
                            nombreCSV={"Plantillas"}                            
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
export default ListaPlantillasInt;